var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dt',{staticClass:"theme-text-dark fw-bold fs-md mb-xs"},[_vm._v(_vm._s(_vm.title))]),_c('dd',{staticClass:"fs-sm theme-text-medium"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }